import * as React from 'react';
import { ListInput, BaseComponentClass, BasicCompoClassProps } from '../generic/ListInput';
import { Form, Header } from 'semantic-ui-react';
import ContactInfoInput from './ContactInfoInput';
import uuid from 'uuid/v1';
import { 
    TriggerSevirity, 
    Conditions as TriggerConditions, 
    TriggerInput as TriggerInterface 
} from 'src/services/graphql/Models';
import validator from 'validator';
import './Triggers.scss';

interface TriggerInputsProps {
    onChange: (e: Event, data: {name: string, value: string}) => any;
    name: string;
    initialValue: any;
    isStateBased?: boolean;
    possibleStates?: string[];
}

const triggerSevirityOptions = [
    {
        key: TriggerSevirity.Informative,
        text: 'Informative',
        value: TriggerSevirity.Informative,
        icon: 'info circle'
    },
    {
        key: TriggerSevirity.Warning,
        text: 'Warning',
        value: TriggerSevirity.Warning,
        icon: 'warning'
    },
    {
        key: TriggerSevirity.Alert,
        text: 'Alert',
        value: TriggerSevirity.Alert,
        icon: 'warning sign'
    },
    {
        key: TriggerSevirity.Critical,
        text: 'Critical',
        value: TriggerSevirity.Critical,
        icon: 'remove circle'
    }
];

const stateBasedConditionOption = [
    {
        key: TriggerConditions.Equal,
        text: 'equal',
        value: TriggerConditions.Equal,
    },
    {
        key: TriggerConditions.NotEqual,
        text: 'unequal',
        value: TriggerConditions.NotEqual,
    }
];

const valueBasedConditionOption = [
    {
        key: TriggerConditions.Equal,
        text: 'equal',
        value: TriggerConditions.Equal,
    },
    {
        key: TriggerConditions.GreaterThan,
        text: 'greater than',
        value: TriggerConditions.GreaterThan,
    },
    {
        key: TriggerConditions.GreaterOrEqual,
        text: 'greater than or equal',
        value: TriggerConditions.GreaterOrEqual,
    },
    {
        key: TriggerConditions.LessThan,
        text: 'less than',
        value: TriggerConditions.LessThan,
    },
    {
        key: TriggerConditions.LessOrEqual,
        text: 'less than or equal',
        value: TriggerConditions.LessOrEqual,
    }
];

class TriggerInput extends BaseComponentClass {
    constructor (props: any) {
        super(props);   
        if (!this.props.value.id) {
            this.state = {
                id: uuid(),
                ...this.props.value
            };
        }
    }
    render() {
        const { 
            name, 
            description,
            triggerSevirity,
            triggerCondition,
            state,
            value,
            contacts,
            notifyOnFailure
        } = this.state;
        const { isStateBased, possibleStates } = this.props;

        return (
            <div>
                <Form.Field>
                    <Form.Input 
                        placeholder="Name for the trigger" 
                        label="Trigger Name"
                        name="name" 
                        defaultValue={name} 
                        onChange={this.changeHandler} 
                    />
                </Form.Field>
                <Form.Field>
                    <Form.TextArea 
                        label="Trigger Description" 
                        onChange={this.changeHandler}
                        placeholder="What is this trigger for?" 
                        name="description" 
                        defaultValue={description} 
                    />
                </Form.Field>
                <Form.Field>
                    <Form.Select
                        label="Trigger Sevirity" 
                        onChange={this.changeHandler}
                        options={triggerSevirityOptions}
                        placeholder="How severe the trigger is?" 
                        name="triggerSevirity" 
                        defaultValue={triggerSevirity} 
                    />
                </Form.Field>
                <Form.Field>
                    <Form.Select
                        label="Trigger Conditions" 
                        onChange={this.changeHandler}
                        options={isStateBased ? stateBasedConditionOption : valueBasedConditionOption}
                        placeholder="Comparision type for the trigger" 
                        name="triggerCondition" 
                        defaultValue={triggerCondition} 
                    />
                </Form.Field>
                <Form.Field>
                    {isStateBased ? 
                        <Form.Select
                            label="Possible States" 
                            onChange={this.changeHandler}
                            options={possibleStates}
                            placeholder="Comparision type for the trigger" 
                            name="state" 
                            defaultValue={state} 
                        />
                        : <Form.Input 
                            placeholder="Trigger Value" 
                            label="Numeric Value"
                            name="value" 
                            defaultValue={value} 
                            onChange={this.changeHandler} 
                        />
                    }
                    
                </Form.Field>
                <Form.Field>        
                    <br/>
                    <label>Trigger when sensor fails</label>
                    <Form.Checkbox 
                        toggle 
                        name="notifyOnFailure" 
                        defaultChecked={notifyOnFailure}
                        onChange={this.handleChecked.bind(this)} 
                    />
                </Form.Field>
                <hr/>
                <div>
                    <Header>Send notification to</Header>
                    <ContactInfoInput 
                        name="contacts"
                        initialValue={contacts || []}
                        onChange={this.changeHandler}
                    />
                </div>
            </div>
        );
    }
}

export default class TriggerInputs extends React.Component<TriggerInputsProps> {
    itemRenderer = this.toTrigger.bind(this);

    validate(_value: TriggerInterface): boolean | any {
        const { 
            name,
            triggerSevirity, 
            triggerCondition, 
            value, 
            state,
            contacts
        } = _value;
        
        let list: string[] = [];

        if (!validator.isIn(triggerSevirity, triggerSevirityOptions.map(
            option => option.value
        ))) {
            list.push('Invalid Trigger Sevirity');
        }

        if (typeof name !== 'string' || name.length < 3) {
            list.push('Name must be more then three character long');
        }
        if (this.props.isStateBased) {
            if (!validator.isIn(triggerCondition, stateBasedConditionOption.map(
                option => option.value
            ))) {
                list.push('Invalid Trigger Condition');
            }
        } else {
            if (!validator.isIn(triggerCondition, valueBasedConditionOption.map(
                option => option.value
            ))) {
                list.push('Invalid Trigger Condition');
            }
        }

        if (
            isNaN(Number(value))
            && !(
                typeof state  === 'string'
                && state.length > 0
            )
        ) {
            list.push('Please provide appropriate trigger value');
        }

        if (!(

            Array.isArray(contacts) 
            && contacts.length > 0

        )) {
            list.push('Please provide contact info of people to send notification to.');
        }

        if (list.length > 0) {
            return {
                header: 'Validation Failed: ',
                list
            };
        } else {
            return true;
        }
        
    }

    handleValuesChange(values: any) {
        this.props.onChange({} as any, { name: this.props.name, value: values});
    }

    toTrigger(props: BasicCompoClassProps) {
        return (
            <TriggerInput 
                {...props}
                isStateBased={this.props.isStateBased}
                possibleStates={this.props.possibleStates}
            />
        );
    }

    render() {
        return (
            <ListInput
                initialValues={this.props.initialValue}
                defaultValue={() => {
                    return  {
                        id: uuid(),
                        triggerSevirity: TriggerSevirity.Informative,
                        triggerCondition: this.props.isStateBased ?
                         TriggerConditions.Equal
                         : TriggerConditions.GreaterOrEqual, 
                        contacts: []
                    };
                }}
                className="trigger-list-input"
                name={this.props.name}
                onValuesChange={this.handleValuesChange.bind(this)}
                validate={this.validate.bind(this)}
                Item={this.itemRenderer}
                StagingItem={this.itemRenderer}
                addButtonText="Add Trigger"
            />
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/inputs/Triggers.tsx